import { render } from "./StudentsMgt.vue?vue&type=template&id=3b033746&scoped=true"
import script from "./StudentsMgt.vue?vue&type=script&lang=js"
export * from "./StudentsMgt.vue?vue&type=script&lang=js"

import "./StudentsMgt.vue?vue&type=style&index=0&id=3b033746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b033746"]])

export default __exports__